export const GTM_TAG_MAP = {
  heycar: 'GTM-TX7GJKX8',
  rac: 'GTM-5NH44HCX',
};
